<template>
    <div class="product-brand">
        <img :src="$storageUrl + imagePath" class="product-brand-img" :alt="title" />
    </div>
</template>

<script>
export default {
    props: {
        imagePath: {},
        title: {},
    },
};
</script>

<style lang="scss" scoped></style>
